import { Button, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/routes'
const AnnouncementsPageHeader = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.announcements.list.pageHeader.title')}
      extra={[
        <Button key="action" type="primary" onClick={() => navigate(routes.createAnnouncement.path)}>
          {t('components.pages.announcements.list.pageHeader.new')}
        </Button>,
      ]}
    />
  )
}

AnnouncementsPageHeader.displayName = 'AnnouncementsPageHeader'
export default AnnouncementsPageHeader
